import {
  INSERT_ORDER_REQUEST,
  INSERT_ORDER_SUCCESS,
  INSERT_ORDER_FAILURE,
} from './paymentType';

const initialState = {
  order: null,
  loading: false,
  error: null,
};

const PaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case INSERT_ORDER_REQUEST:
      return { ...state, loading: true, error: null };
    case INSERT_ORDER_SUCCESS:
      return { ...state, loading: false, order: action.payload };
    case INSERT_ORDER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default PaymentReducer;
